module.exports = __webpack_public_path__ + "assets/img/d1e0e899845da657c974744750b426fc.png";